import { useEffect } from 'react'
import * as BABYLON from '@babylonjs/core'
import { buildMountainLot, LotPhoto } from './buildMountainLot'

/** Owns buildMountainLot's lifecycle for one scene/photos pair — rebuilds if either changes identity. */
export function useMountainLotScene(scene: BABYLON.Scene | null, canvasRef: React.RefObject<HTMLCanvasElement>, photos: LotPhoto[]) {
  useEffect(() => {
    if (!scene || !canvasRef.current) return
    const api = buildMountainLot(scene, canvasRef.current, photos)
    return () => api.dispose()
  }, [scene, canvasRef, photos])
}
